import {
  VisualIdentityCreateRequest,
  VisualIdentityResponse,
  VisualIdentityUpdateRequest,
} from 'api/core';
import {
  useCreateVisualIdentity,
  useUpdateVisualIdentity,
} from 'api/useVisualIdentitiesApi';
import { LabelWithHelperText } from 'components/Form/LabelWithHelperText';
import { useForm } from 'react-hook-form';

const themes = [
  {
    value: 'smartcreate',
    label: 'Standard',
  },
  {
    value: 'edc',
    label: 'EDC',
  },
  {
    value: 'edc_erhverv',
    label: 'EDC Erhverv',
  },
  {
    value: 'nybolig',
    label: 'Nybolig',
  },
];

interface VisualIdentityFormProps {
  targetVisualIdentity?: VisualIdentityResponse;
  onSuccess: () => void;
  onCancel: () => void;
  inDialog?: boolean;
}

export const VisualIdentityForm = ({
  targetVisualIdentity,
  onSuccess,
  onCancel,
  inDialog = false,
}: VisualIdentityFormProps) => {
  const { mutateAsync: createAsync, isPending: isPendingCreate } =
    useCreateVisualIdentity();
  const { mutateAsync: updateAsync, isPending: isPendingUpdate } =
    useUpdateVisualIdentity();

  const { register, handleSubmit } = useForm<
    VisualIdentityCreateRequest | VisualIdentityUpdateRequest
  >({
    defaultValues: targetVisualIdentity,
  });

  const onSubmit = handleSubmit(async (result) => {
    if (targetVisualIdentity) {
      await updateAsync({
        id: targetVisualIdentity.id,
        visualIdentityUpdateRequest: result,
      });
    } else {
      await createAsync({
        visualIdentityCreateRequest: result,
      });
    }
    onSuccess();
  });

  return (
    <form onSubmit={onSubmit} className="space-y-2">
      <div className="form-control">
        <label className="label">
          <span className="label-text">Navn</span>
        </label>
        <input
          {...register('name', { required: true })}
          type="text"
          className="input input-bordered"
        />
      </div>

      <div className="form-control">
        <label className="label">
          <span className="label-text">Tema</span>
        </label>
        <select
          {...register('tailwindName', { required: true })}
          className="select select-bordered"
        >
          {themes.map((theme) => (
            <option key={theme.value} value={theme.value}>
              {theme.label}
            </option>
          ))}
        </select>
      </div>
      <div className="form-control">
        <LabelWithHelperText
          label="Logo"
          helperText="URL til logoet. Det skal være en offentlig tilgængelig URL."
          htmlFor="logoUrl"
          inDialog={inDialog}
        />
        <input
          {...register('logoUrl', { required: true })}
          type="text"
          className="input input-bordered"
          placeholder="https://s3.eu-central-1.amazonaws.com/assets.estateengine.dk/05897d48-f595-43c7-850d-9624363b2197.png"
        />
      </div>

      <div className="flex justify-center space-x-4 pt-4">
        <button
          className="btn btn-primary"
          disabled={isPendingCreate || isPendingUpdate}
        >
          {targetVisualIdentity ? 'Opdater' : 'Opret'}
        </button>
        {onCancel ? (
          <button type="button" className="btn" onClick={onCancel}>
            Annuller
          </button>
        ) : null}
      </div>
    </form>
  );
};
